// extracted by mini-css-extract-plugin
module.exports = {"input":"InputCode_input__BtNjv"};